export const messages = {
    en: {
      myRepairDispatchManage: {
        queryCondition: 'Query Conditions',
        selectMaintenanceType: 'Select Maintenance Type',
        inputRepairName: 'Enter Reporter Name',
        inputRepairTel: 'Enter Reporter Phone',
        selectRepairType: 'Select Repair Type',
        selectRepairState: 'Select Repair State',
        inputRepairId: 'Enter Work Order ID',
        repairDispatch: 'Repair Dispatch',
        repairId: 'Work Order ID',
        location: 'Location',
        repairType: 'Repair Type',
        maintenanceType: 'Maintenance Type',
        repairPerson: 'Reporter',
        contact: 'Contact',
        appointmentTime: 'Appointment Time',
        state: 'Status',
        operation: 'Operation',
        detail: 'Detail',
        scheduledTask: 'Scheduled Task',
        paidService: 'Paid Service',
        freeService: 'Free Service',
        needMaterial: 'Need Material',
        noMaterial: 'No Material'
      },
      closeOrder: {
        closeOrderInfo: 'Close Order Information',
        closeStatus: 'Close Status',
        selectCloseStatus: 'Please select',
        closeOrder: 'Close Order',
        returnOrder: 'Return Order',
        reason: 'Reason',
        reasonPlaceholder: 'Optional, please fill in the reason',
        processed: 'Processed'
      }
    },
    zh: {
      myRepairDispatchManage: {
        queryCondition: '查询条件',
        selectMaintenanceType: '请选择维修类型',
        inputRepairName: '请输入报修人',
        inputRepairTel: '请输入报修电话',
        selectRepairType: '请选择报修类型',
        selectRepairState: '请选择报修状态',
        inputRepairId: '请输入工单编号',
        repairDispatch: '报修已办',
        repairId: '工单编号',
        location: '位置',
        repairType: '报修类型',
        maintenanceType: '维修类型',
        repairPerson: '报修人',
        contact: '联系方式',
        appointmentTime: '预约时间',
        state: '状态',
        operation: '操作',
        detail: '详情',
        scheduledTask: '定时任务处理',
        paidService: '有偿服务',
        freeService: '无偿服务',
        needMaterial: '需要用料',
        noMaterial: '无需用料'
      },
      closeOrder: {
        closeOrderInfo: '结单信息',
        closeStatus: '结单状态',
        selectCloseStatus: '请选择',
        closeOrder: '结单',
        returnOrder: '退单',
        reason: '原因',
        reasonPlaceholder: '选填，请填写原因',
        processed: '已处理'
      }
    },
    'zh-TW': {
      myRepairDispatchManage: {
        queryCondition: '查詢條件',
        selectMaintenanceType: '請選擇維修類型',
        inputRepairName: '請輸入報修人',
        inputRepairTel: '請輸入報修電話',
        selectRepairType: '請選擇報修類型',
        selectRepairState: '請選擇報修狀態',
        inputRepairId: '請輸入工單編號',
        repairDispatch: '報修已辦',
        repairId: '工單編號',
        location: '位置',
        repairType: '報修類型',
        maintenanceType: '維修類型',
        repairPerson: '報修人',
        contact: '聯繫方式',
        appointmentTime: '預約時間',
        state: '狀態',
        operation: '操作',
        detail: '詳情',
        scheduledTask: '定時任務處理',
        paidService: '有償服務',
        freeService: '无偿服務',
        needMaterial: '需要用料',
        noMaterial: '無需用料'
      },
      closeOrder: {
        closeOrderInfo: '結單信息',
        closeStatus: '結單狀態',
        selectCloseStatus: '請選擇',
        closeOrder: '結單',
        returnOrder: '退單',
        reason: '原因',
        reasonPlaceholder: '選填，請填寫原因',
        processed: '已處理'
      }
    }
  }